
import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";


export default class Menu {
    static init(){
        const el = document.querySelector('[data-hero-home]');
		new Menu(el);
	}

	constructor(el) {

        if (!el) {
            return;
		}

        const isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;
        let wordsLine1 = ["projectmanager", "organisatieveranderaars", "communicado's", "facilitators", "onderzoekers", "ontwerpers"];

        if(isMobile) {
            wordsLine1 = ["projectmanager", "communicado", "facilitator", "onderzoeker", "ontwerper"]
        }

        gsap.registerPlugin(TextPlugin);

        let line1Tl = gsap.timeline({repeat: -1});

        wordsLine1.forEach(word => {
            let tl = gsap.timeline({
                repeat: 1,
                yoyo: true,
                repeatDelay: 1,
            })
            tl.to('.text1', {
                duration: 1,
                text: {
                    value: word,
                    delimiter: " ",
                },
                ease: "power4"
            })
            line1Tl.add(tl)
        })

        let wordsLine2 = ["een ondernemende mindset", "vernieuwende ideeën", "daadkracht", "onbevangen enthousiasme"]

        if(isMobile) {
            wordsLine2 = ["ideeën", "daadkracht", "enthousiasme"]
        }

        let line2Tl = gsap.timeline({repeat: -1});

        wordsLine2.forEach(word => {
            let tl = gsap.timeline({
                repeat: 1,
                yoyo: true,
                repeatDelay: 1,
            })
            tl.to('.text2', {
                duration: 1,
                text: {
                    value: word,
                    delimiter: " ",
                },
                ease: "power4"
            })
            line2Tl.add(tl)
        })
	}
}
